export default "__VITE_ASSET__19098383__"